export default class BlackList {
    constructor() {
        this.number = 6;
        this.label = 'Sort plakatliste';
        this.image_name = 'black-list';
        this.id = 'frame-' + this.image_name;
        this.path = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/';
        this.extension = '.png';
        this.src =  this.path + this.image_name + this.extension;
        this.paperOuterPadding = 0;
        this.addFrameShadow = false;
        this.frameCount = 1;
    }
}
